import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

// 引入局部的数据
import audioState from "@/store/audioState"; // 音频状态
import krpanoData from "@/store/krpanoData"; // 全景数据
import mapData from "@/store/mapData"; // 地图数据
import publicData from "@/store/publicData"; // 公用数据
import albumData from "@/store/albumData"; // 相册数据
export default new Vuex.Store({
    modules: {
        audioState,
        krpanoData,
        mapData,
        publicData,
        albumData
    },
})
